import React, {Component} from "react"
import {connect} from 'react-redux';
import Layout from "../../../components/Layout"
import "./index.scss"


import CustomTable from "../../../components/CustomTableGrid";
//import {columns, rows, headerInformation} from '../../../components/CustomTable/helpers/tableValuesEdit'

import {
    schedule_get_rows_forecast, schedule_set_forecast,
} from "../../../store/actions/schedule";

import {
    Grid,
    Breadcrumb,
    BreadcrumbItem,
    DataTableSkeleton,
    ComposedModal,
    ModalHeader,
    ModalBody,
} from "carbon-components-react";

import leng from "../../../data";

import moment from "moment";
import LogRocket from "logrocket";

//import data from "../../../data";


class Edit extends Component {

    state = {
        rf_mes_edit: "",
        mes_inicio: "",
        mes_fim: "",
        data_corrente: "",
        liberado: true,
        rf_ano: "",
        modal_save: false,
    };

    async componentDidMount() {
        try {
            const rf = this.props.match.params.rf.split(" ");
            let rf_corrente = rf[0];
            let rf_ano = rf[1];
            let data_corrente = "";
            let data_actual;
            let data_fim_rf;
            let soma_meses = 13;
            let liberado = true;
            // console.log(rf_ano);

            if (rf_corrente === "RF1") {
                rf_ano = rf_ano > new Date().getFullYear() ? new Date().getFullYear() : rf_ano
                data_corrente = new Date(rf_ano + "-10-02");
                soma_meses = 14
                if (rf_ano <= data_corrente.getFullYear() && new Date().getMonth() !== 11)
                    liberado = false;
                this.setState({rf_mes_edit: 11}); // era 10 foi para 11
            } else if (rf_corrente == "RF2") {
                data_corrente = new Date(rf_ano + "-01-02");
                this.setState({rf_mes_edit: 1}); // era 0 foi para 1
                if (rf_ano <= data_corrente.getFullYear() && new Date().getMonth() != 1)
                    liberado = false;
            } else if (rf_corrente == "RF3") {
                data_corrente = new Date(rf_ano + "-04-02");
                this.setState({rf_mes_edit: 4}); // era 3 foi para 4
                if (rf_ano <= data_corrente.getFullYear() && new Date().getMonth() != 4)
                    liberado = false;
            } else if (rf_corrente == "RF4") {
                data_corrente = new Date(rf_ano + "-07-02")
                this.setState({rf_mes_edit: 7}); // era 6 foi para 7
                if (rf_ano <= data_corrente.getFullYear() && new Date().getMonth() != 7)
                    liberado = false;
            }


            this.setState({data_corrente: data_corrente, "liberado": liberado, rf_ano: rf_ano});


            data_actual = new Date(data_corrente);
            //  console.log(data_actual);
            data_fim_rf = new Date(data_corrente);
            data_actual.setMonth(data_actual.getMonth() - 11);
            data_fim_rf.setMonth(data_fim_rf.getMonth() + soma_meses);
            this.setState({mes_inicio: data_actual, mes_fim: data_fim_rf});

            //console.log(data_actual);

            await this.props.fetchData({
                'cost_center_concat': this.props.match.params.cost_center_concat,
                'rf': this.props.match.params.rf,
                'mes_inicio': data_actual,
                'mes_fim': data_fim_rf,
            });
        } catch (e) {
            console.error(e);
        }
    }

    async saveForecast(unmutableRows, object) {
        //console.log("1--->", object, " ", unrows)
        await this.props.fetchSetData(unmutableRows, object, this.state.data_corrente).then(data => {
            this.handleLoadingTabela();
        }).then(data => {
            this.setState({modal_save: true})
        }).catch(err => {
            LogRocket.captureException(err);
            return false;
        });
    }

    handleLoadingTabela = async (e) => {
        await this.props.fetchData({
            'cost_center_concat': this.props.match.params.cost_center_concat,
            'rf': this.props.match.params.rf,
            'mes_inicio': this.state.mes_inicio,
            'mes_fim': this.state.mes_fim,
        }).then(data => {
            return true;
        }).catch(err => {
            LogRocket.captureException(err);
            return false;
        })
    };


    render() {

        function converteMoedaFloat(valor) {
            if (valor === "") {
                valor = 0;
            } else {
                valor = valor.replace(/[.]/g, "");
                valor = valor.replace(",", ".");
                valor = parseFloat(valor);
            }
            return valor;

        }

        function calcular_somatoria_total(obj, primeiro_dezembro, segundo_dezembro = false, nivel_03) {
            let somatoria = 0;
            if (!segundo_dezembro) {
                Object.keys(obj).forEach(key => {
                    if (!isNaN(Date.parse(key))) {
                        if (key < primeiro_dezembro)

                            somatoria += nivel_03 ? parseFloat(obj[key]) : converteMoedaFloat(obj[key]);
                    }
                })
            } else {
                Object.keys(obj).forEach(key => {
                    if (!isNaN(Date.parse(key))) {
                        if (key > primeiro_dezembro && key < segundo_dezembro)
                            somatoria += nivel_03 ? parseFloat(obj[key]) : converteMoedaFloat(obj[key]);
                    }
                })
            }
            return somatoria.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            ;
        }

        let {data, isLoading, isLoadingForecast, planning} = this.props;
        let rf = this.props.match.params.rf;
        const columns = [
            {
                name: 'acc_description_edit',
                title: 'ACC DESCRIPTION',
                editable: false,
                width: 500,
                order: 0,
                height: 38
            },
        ];

        const callApi = (unmutableRows, object) => this.saveForecast(unmutableRows, object);

        let rows = [];
        let unrows = [];
        var total_calculado = false;
        var last_level_descr = "";
        var last_acc_concat = "";

        if (this.state.rf_ano !== "") {

            var mes_edit = this.state.rf_mes_edit;
            var data_corrente = this.state.data_corrente;
            var liberado = this.state.liberado;
            var rf_ano = this.state.rf_ano;

            var objeto_nivel_total = new Object();
            objeto_nivel_total["id"] = 'TOTAL';
            objeto_nivel_total["acc_description_edit"] = 'TOTAL';
            objeto_nivel_total["parentId"] = null;
            objeto_nivel_total["type"] = 'step-total';
            objeto_nivel_total["editado"] = false;

            var primeiro_dez = new Date(rf_ano + "-12-20").toISOString();
            var segundo_dez = new Date((parseInt(rf_ano) + 1) + "-12-20").toISOString();
        }
        if (data?.length > 0) {
            data.forEach(function (dados) {
                    if ((last_acc_concat == "" || last_acc_concat !== dados.account_concat) && (!rows.some(row => row.acc_description_edit === dados.account_concat))) {
                        var objeto_nivel01 = new Object();
                        var objeto_nivel02 = new Object();
                        var objeto_nivel03 = new Object();
                        var objeto_nivel03_unRows = new Object();
                        var existe_rf = false;

                        if (!rows.some(row => row.acc_description_edit === dados.level_descr)) {
                            objeto_nivel01["id"] = dados.level_descr;
                            objeto_nivel01["acc_description_edit"] = dados.level_descr;
                            objeto_nivel01["parentId"] = null;
                            objeto_nivel01["type"] = 'step';
                            objeto_nivel01["editado"] = false;
                            last_level_descr = dados.level_descr
                        }

                        if (!rows.some(row => row.acc_description_edit === dados.group_level_2 && row.parentId == dados.level_descr)) {
                            // aux_id_nivel_02 = dados.group_level_2 + "_" + Math.random().toString(36).substr(2, 9);
                            //  objeto_nivel02["id"] = aux_id_nivel_02;
                            objeto_nivel02["id"] = dados.group_level_2 + dados.level_descr;
                            objeto_nivel02["acc_description_edit"] = dados.group_level_2;
                            objeto_nivel02["parentId"] = dados.level_descr;
                            objeto_nivel02["type"] = 'step';
                            objeto_nivel02["editado"] = false;

                            //  console.log("IF02-->", aux_id_nivel_02);
                        }

                        if (!rows.some(row => row.acc_description_edit == dados.account_concat && row.parentId == (dados.group_level_2 + dados.level_descr))) {
                            objeto_nivel03["id"] = Math.random().toString(36).substr(2, 9);
                            objeto_nivel03["acc_description_edit"] = dados.account_concat;
                            objeto_nivel03["parentId"] = dados.group_level_2 + dados.level_descr;
                            objeto_nivel03["cost_center"] = dados.cost_center;
                            objeto_nivel03["type"] = "row";
                            objeto_nivel03["editado"] = false;
                            objeto_nivel03["level_descr"] = dados.level_descr;
                            objeto_nivel03["rf"] = rf;

                            objeto_nivel03_unRows["id"] = Math.random().toString(22).substr(2, 9);
                            objeto_nivel03_unRows["acc_description_edit"] = dados.account_concat;
                            objeto_nivel03_unRows["parentId"] = dados.group_level_2 + dados.level_descr;
                            objeto_nivel03_unRows["cost_center"] = dados.cost_center;
                            objeto_nivel03_unRows["type"] = "row";
                            objeto_nivel03_unRows["editado"] = false;
                            objeto_nivel03_unRows["level_descr"] = dados.level_descr;
                            objeto_nivel03_unRows["rf"] = rf;


                            // console.log("IF03-->", aux_id_nivel_02);
                        }

                        var colunas_rf = data.filter(colunas => colunas.account_concat == objeto_nivel03["acc_description_edit"] && colunas.rf == rf);
                        colunas_rf.forEach(coluna => {

                            var date = new Date(coluna.data_ref).toISOString();
                            var array_para_somar = data.filter(obj => (obj.level_descr == objeto_nivel01["acc_description_edit"] && obj.data_ref == coluna.data_ref && obj.rf == rf));
                            var total = array_para_somar.reduce((forecast_acumulado, forecast) => (parseFloat(forecast_acumulado) + parseFloat(forecast.forecast)), 0);

                            var array_para_somar_nivel02 = data.filter(obj => (obj.group_level_2 + obj.level_descr == objeto_nivel02["id"] && obj.data_ref == coluna.data_ref && obj.rf == rf));
                            var total_nivel02 = array_para_somar_nivel02.reduce((forecast_acumulado, forecast) => (parseFloat(forecast_acumulado) + parseFloat(forecast.forecast)), 0);


                            objeto_nivel01[date] = total.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            });
                            objeto_nivel02[date] = total_nivel02.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            });


                            objeto_nivel03[date] = parseFloat(coluna.forecast).toFixed(2);
                            objeto_nivel03_unRows[date] = parseFloat(coluna.forecast).toFixed(2);
                            if (!columns.some(column => column.name === new Date(coluna.data_ref).toISOString())) {
                                if ((new Date(coluna.data_ref)) >= (new Date(data_corrente))) {
                                    var objeto_coluna = new Object();
                                    objeto_coluna['name'] = new Date(coluna.data_ref).toISOString();
                                    objeto_coluna['title'] = moment(coluna.data_ref).format('MMM YY');
                                    objeto_coluna['order'] = (new Date(coluna.data_ref));
                                    objeto_coluna['height'] = 38;
                                    if ((new Date().getMonth()) == mes_edit) {
                                        objeto_coluna['editable'] = true;
                                    } else {
                                        objeto_coluna['editable'] = false;
                                    }
                                    objeto_coluna['width'] = 180;
                                    columns.push(objeto_coluna);
                                }
                            }
                            existe_rf = true
                        })

                        var colunas_actual_nivel01 = data.filter(colunas => colunas.level_descr == objeto_nivel01["acc_description_edit"] && colunas.rf == 'actual');
                        colunas_actual_nivel01.forEach(coluna_actual_n1 => {
                            var date = new Date(coluna_actual_n1.data_ref).toISOString();
                            var array_para_somar = colunas_actual_nivel01.filter(obj => (obj.level_descr == objeto_nivel01["acc_description_edit"] && obj.data_ref == coluna_actual_n1.data_ref));
                            var total = array_para_somar.reduce((forecast_acumulado, forecast) => (parseFloat(forecast_acumulado) + parseFloat(forecast.value)), 0);
                            objeto_nivel01[date] = total.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            });
                            if (!columns.some(column => column.name === new Date(coluna_actual_n1.data_ref).toISOString())) {
                                if (((new Date(coluna_actual_n1.data_ref)) <= (new Date(data_corrente))) || !liberado) {

                                    var objeto_coluna = new Object();
                                    objeto_coluna['name'] = new Date(coluna_actual_n1.data_ref).toISOString();
                                    objeto_coluna['title'] = moment(coluna_actual_n1.data_ref).format('MMM YY');
                                    objeto_coluna['order'] = (new Date(coluna_actual_n1.data_ref));
                                    objeto_coluna['editable'] = false;
                                    objeto_coluna['width'] = 180;
                                    objeto_coluna['height'] = 38;

                                }
                                if (!columns.some(column => column.name === primeiro_dez)) {
                                    objeto_coluna['name'] = primeiro_dez;
                                    objeto_coluna['title'] = "Total " + moment(primeiro_dez).format('YY');
                                    objeto_coluna['order'] = (new Date(primeiro_dez));
                                    objeto_coluna['editable'] = false;
                                    objeto_coluna['total'] = true;
                                    objeto_coluna['width'] = 180;
                                    objeto_coluna['height'] = 38;
                                }
                                if (!columns.some(column => column.name === segundo_dez)) {
                                    objeto_coluna['name'] = segundo_dez;
                                    objeto_coluna['title'] = "Total " + moment(segundo_dez).format('YY');
                                    objeto_coluna['order'] = (new Date(segundo_dez));
                                    objeto_coluna['editable'] = false;
                                    objeto_coluna['total'] = true;
                                    objeto_coluna['width'] = 180;
                                    objeto_coluna['height'] = 38;
                                }
                                columns.push(objeto_coluna);
                            }

                        })

                        var colunas_actual_nivel02 = data.filter(colunas => colunas.group_level_2 == objeto_nivel02["acc_description_edit"] && colunas.rf == 'actual');
                        colunas_actual_nivel02.forEach(coluna_actual_n2 => {
                            var date = new Date(coluna_actual_n2.data_ref).toISOString();
                            var array_para_somar = colunas_actual_nivel02.filter(obj => (obj.group_level_2 == objeto_nivel02["acc_description_edit"] && obj.level_descr == last_level_descr && obj.data_ref == coluna_actual_n2.data_ref));
                            // console.log(objeto_nivel02["acc_description_edit"], " ||||| ", last_level_descr, "   | ARRAY SOMA 02->", array_para_somar);
                            var total = array_para_somar.reduce((forecast_acumulado, forecast) => (parseFloat(forecast_acumulado) + parseFloat(forecast.value)), 0);
                            objeto_nivel02[date] = total.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            });
                        })

                        var colunas_actual_nivel03 = data.filter(colunas => colunas.account_concat == objeto_nivel03["acc_description_edit"] && colunas.rf == 'actual');
                        colunas_actual_nivel03.forEach(coluna_actual_n3 => {
                            var date = new Date(coluna_actual_n3.data_ref).toISOString();
                            var array_para_somar = colunas_actual_nivel03.filter(obj => (obj.account_concat == objeto_nivel03["acc_description_edit"] && obj.data_ref == coluna_actual_n3.data_ref));
                            var total = array_para_somar.reduce((forecast_acumulado, forecast) => (parseFloat(forecast_acumulado) + parseFloat(forecast.value)), 0);
                            objeto_nivel03[date] = parseFloat(total).toFixed(2)
                            objeto_nivel03_unRows[date] = parseFloat(total).toFixed(2)
                        })

                        if (!total_calculado) {
                            data.forEach(coluna_total_n1 => {

                                    var date = new Date(coluna_total_n1.data_ref).toISOString();
                                    var array_para_somar = data.filter(obj => (obj.data_ref == coluna_total_n1.data_ref));
                                    var total = 0;
                                    if (date <= data_corrente.toISOString() || !liberado) {
                                        total = array_para_somar.reduce((forecast_acumulado, forecast) => (parseFloat(forecast_acumulado) + parseFloat(forecast.value)), 0);
                                    } else {
                                        total = array_para_somar.reduce((forecast_acumulado, forecast) => (parseFloat(forecast_acumulado) + parseFloat(forecast.forecast)), 0);
                                    }
                                    objeto_nivel_total[date] = total.toLocaleString('pt-BR', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    });
                                }
                            )

                            total_calculado = true;
                        }
                        last_acc_concat = dados.account_concat;

                        objeto_nivel01[primeiro_dez] = calcular_somatoria_total(objeto_nivel01, primeiro_dez)
                        objeto_nivel01[segundo_dez] = calcular_somatoria_total(objeto_nivel01, primeiro_dez, segundo_dez);

                        objeto_nivel02[primeiro_dez] = calcular_somatoria_total(objeto_nivel02, primeiro_dez);
                        objeto_nivel02[segundo_dez] = calcular_somatoria_total(objeto_nivel02, primeiro_dez, segundo_dez);

                        objeto_nivel03[primeiro_dez] = calcular_somatoria_total(objeto_nivel03, primeiro_dez, false, true);
                        objeto_nivel03[segundo_dez] = calcular_somatoria_total(objeto_nivel03, primeiro_dez, segundo_dez, true);

                        objeto_nivel03_unRows[primeiro_dez] = calcular_somatoria_total(objeto_nivel03, primeiro_dez, false, true);
                        objeto_nivel03_unRows[segundo_dez] = calcular_somatoria_total(objeto_nivel03, primeiro_dez, segundo_dez, true);

                        objeto_nivel_total[primeiro_dez] = calcular_somatoria_total(objeto_nivel_total, primeiro_dez);
                        objeto_nivel_total[segundo_dez] = calcular_somatoria_total(objeto_nivel_total, primeiro_dez, segundo_dez);

                        rows.push(objeto_nivel01);
                        rows.push(objeto_nivel02);

                        if (!existe_rf)
                            objeto_nivel03["type"] = "step-row";
                        unrows.push(objeto_nivel03_unRows);
                        rows.push(objeto_nivel03);

                    }
                }
            );

            rows.push(objeto_nivel_total);
            columns.sort(function (a, b) {
                return a.order > b.order ? 1 : -1;
            });
            //  console.log("1--->", unrows);
            // console.log("--->", unrows);
        }
        return (
            <Layout>
                <Grid class="painel" fullWidth>
                    <div className="container-fluid">
                        <div className="header-text header-text-report">
                            <h5>{leng.sideBar.intelligentJourney.title}</h5>
                            <h3>Planning Review</h3>
                            <Breadcrumb noTrailingSlash>
                                <BreadcrumbItem style={{color: "#000000"}}
                                                href="/ij/report_create_schneider"
                                >Filtering</BreadcrumbItem>
                            </Breadcrumb>
                        </div>
                        {
                            isLoadingForecast ? (
                                <>
                                    <ComposedModal size="xs" open preventCloseOnClickOutside>
                                        <ModalHeader title="Status"/>
                                        <ModalBody>
                                            Salvando Dados...
                                        </ModalBody>
                                    </ComposedModal>
                                    <div style={{paddingTop: "30px", paddingRight: "20px", marginBottom: "50px"}}>
                                        <DataTableSkeleton/>
                                    </div>
                                </>
                            ) : (

                                <>
                                    {this.state.modal_save && (
                                        <ComposedModal size="xs" open preventCloseOnClickOutside>
                                            <ModalHeader title="Status"/>
                                            <ModalBody>
                                                Salvando Dados...
                                            </ModalBody>
                                        </ComposedModal>
                                    )}
                                    {isLoading ? (
                                        <div style={{paddingTop: "30px", paddingRight: "20px", marginBottom: "50px"}}>
                                            <DataTableSkeleton/>
                                        </div>
                                    ) : (
                                        <>
                                            {this.state.modal_save && (
                                                <ComposedModal size="xs" open preventCloseOnClickOutside
                                                               onClose={() => this.setState({modal_save: false})}>
                                                    <ModalHeader title="Status"/>
                                                    <ModalBody>
                                                        Salvo com sucesso!
                                                    </ModalBody>
                                                </ComposedModal>
                                            )}
                                            <div style={{
                                                paddingTop: "30px",
                                                paddingRight: "20px",
                                                marginBottom: "50px"
                                            }}>
                                                <CustomTable headerInformation={{
                                                    "title": this.props.match.params.cost_center_concat,
                                                    date: this.props.match.params.rf
                                                }}
                                                             unmutableRows={unrows}
                                                             columns={columns}
                                                             rowsData={rows}
                                                             editable={true}
                                                             refreshData={callApi}
                                                             undoData={this.handleLoadingTabela}
                                                />
                                            </div>
                                        </>
                                    )}
                                </>
                            )}


                    </div>
                </Grid>
            </Layout>
        )
    }
}

const
    mapStateToProps = ({schedule}) => schedule;

const
    mapDispatchToProps = dispatch => ({
        fetchData: (filtros) => dispatch(schedule_get_rows_forecast(filtros)),
        fetchSetData: (unmobject, object, data_corrente) => dispatch(schedule_set_forecast(unmobject, object, data_corrente)),
    });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)

(
    Edit
)
;
